import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils } from 'versafleet-core';

class TaskDriverTagForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { form: { tag_list: [] } };
  }

  _onFormModified(fieldName, value) {
    this.setState((prevState) => {
      const form = prevState.form;
      form[fieldName] = value;

      return {
        form,
      };
    });
  }

  render() {
    return (
      <div
        className="vf-task__tag__form-container"
        onClick={e => e.stopPropagation()}
      >
        <h6 className="vf-task__tag__form__title">Add Tags</h6>
        <div className="vf-task__tag__form__row">
          <i className="versa-tags" />
          <Components.Input.Tag
            allowCustom
            className="vf-task__tag__form__input"
            onChange={val => this._onFormModified('tag_list', val)}
            options={Utils.Helper.isNullOrUndefined(this.props.tags)
              ? [] : this.props.tags.map(tag => ({ value: tag, text: tag }))}
            placeholder="e.g. fragile, west"
            value={this.state.form.tag_list}
          />
        </div>
        <div className="vf-task__tag__form__note">
          <p>
            Adding tags will not replace existing ones.
          </p>
        </div>
        <Components.Button
          className="vf-task__tag__form__button"
          iconClassName="versa-completed"
          loading={this.props.loading}
          onClick={() => this.props.tagMultiple(this.props.ids, this.state.form.tag_list)}
        >
          {this.props.loading ? 'Adding Tags' : 'Add Tags'}
        </Components.Button>
      </div>
    );
  }
}

TaskDriverTagForm.displayName = 'Task Driver Tag Form';

TaskDriverTagForm.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.number),
  loading: PropTypes.bool,
  tagMultiple: PropTypes.func,
  tags: PropTypes.arrayOf(PropTypes.string),
};

TaskDriverTagForm.defaultProps = {
  ids: [],
  loading: false,
  tagMultiple: () => {},
  tags: [],
};

export default TaskDriverTagForm;
